import React, { useContext } from 'react';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/admin/adminBlogs/admBlogHeader.css';

const AdmBlogHeader = () => {
  const { blogs, openCreateBlog } = useContext(AppContext);

  const total     = blogs.length;
  const published = blogs.filter(b => b.post_status === 'published').length;
  const draft     = blogs.filter(b => b.post_status === 'draft').length;

  return (
    <div className="adm-blog-header">

      <div className="adm-blog-header-left">
        <div className="adm-blog-header-text">
          <h1>Blog Management</h1>
          <p>{total} total • {published} published • {draft} drafts</p>
        </div>
      </div>

      <button className="adm-blog-btn-create-blog" onClick={openCreateBlog}>
        <span>➕</span> Create New Blog
      </button>

    </div>
  );
};

export default AdmBlogHeader;